import { useState, useEffect } from 'react';
import QoCService from '../services/QoCService';
import moment from 'moment';

export function usePeriods() {
    const [periods,       setPeriods]       = useState([]);
    const [currentPeriod, setCurrentPeriod] = useState(null);
    const [loading,       setPLoading]      = useState(true);

    useEffect(() => {
        QoCService.getPeriods()
            .then(r => {
                const all    = r.data?.data || [];
                const active = all.filter(p => parseInt(p.is_active) === 1);
                setPeriods(active);
                const cur = active.find(p => parseInt(p.is_current) === 1) || active[0] || null;
                setCurrentPeriod(cur);
            })
            .catch(() => {})
            .finally(() => setPLoading(false));
    }, []);

    return { periods, currentPeriod, periodsLoading: loading };
}

export function periodToForm(p) {
    if (!p) return { period_label: '', period_start: null, period_end: null };
    return {
        period_label: p.label,
        period_start: moment(p.period_start),
        period_end:   moment(p.period_end),
    };
}
